<template>
  <div class="l-row">
    <form-group :label="$t('category.label')">
      <select class="form-select" v-model="newItem.from.category" :columns="3">
        <option :value=null>{{ $t('choose.label') }}</option>
        <option v-for="(category, index) in from.categories" v-if="showItem[index]" :key="category" :value="category">{{ category }}</option>
      </select>
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <div class="l-col-6@md">
      <category-cascade ref="cascade" @change="onCascadeChange" @loading="loaderCategoriesMarketplace = $event; emitLoading()"/>
    </div>

    <slot/>
  </div>
</template>

<script>
  import { isArray } from 'lodash'
  import FormGroup from '@/components/template/FormGroup'
  import CategoryCascade from './CategoryCascade'
  import api from '@/api'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      from: {
        categories: []
      },
      newItem: {
        from: {
          category: null
        },
        to: {
          categories: []
        }
      },
      alreadyExists: false,
      showItem: [],
      loaderCategoriesEcommerce: true,
      loaderCategoriesMarketplace: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getCategories(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(categories => {
          this.from.categories = categories
          this.loaderCategoriesEcommerce = false
          this.fillShowItem()
          this.$emit('showItem', true)
          this.emitLoading()
        })
        .catch(() => notifier.error('Impossível carregar as categorias da Moovin.', 'Erro'))
    },
    methods: {
      emitLoading () {
        this.$emit('loading', this.loaderCategoriesEcommerce || this.loaderCategoriesMarketplace)
      },
      onCascadeChange (path) {
        this.newItem.to.categories = path
        this.emitEnabledAdd()
      },
      isEnableAddButton () {
        const categories = this.newItem.to.categories
        const last = categories[categories.length - 1]

        return this.newItem.from.category !== null && !!last && last.last_category === true
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            category: this.newItem.from.category
          },
          to: {
            categories: this.newItem.to.categories.map(category => ({ ...category }))
          }
        }

        const itemExist = this.preset.items.filter(itemPreset => itemPreset.from.category === item.from.category)

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'active': this.preset.active,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      },
      clearPresetAddItem () {
        if (!this.alreadyExists) {
          this.$refs.cascade.reset()
          this.newItem.from.category = null
        }
      },
      fillShowItem () {
        if (isArray(this.from['categories']) && this.from['categories'].length) {
          for (let j in this.from['categories']) {
            const item = this.from['categories'][j]

            this.showItem[j] = !this.preset.items.find(preset => preset.from.category === item)
          }
        }
      }
    },
    watch: {
      'preset.items' () {
        this.fillShowItem()
      },
      'newItem.from.category' () {
        this.emitEnabledAdd()
      }
    },
    components: {
      FormGroup,
      CategoryCascade
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationAddItem.vue?6d49ef24